import { createAction, props } from "@ngrx/store";

export const addSlug = createAction('[Loading Indicator] Add Slug', props<{ slug: string; }>());
export const addGroupSlugs = createAction('[Loading Indicator] Add Group Slug', props<{ slugs: string[]; }>());
export const deleteSlug = createAction('[Loading Indicator] Delete Slug', props<{ slug: string; }>());
export const deletePendingSlugs = createAction('[Loading Indicator] Delete Pending Slugs', props<{ functionName: string; }>());
export const deleteFinishedSlugs = createAction('[Loading Indicator] Delete Finished Slug', props<{ functionName: string; }>());